module.exports = __webpack_public_path__ + "media/images/ai_brain_topics/voice_tone-6b1edfa84a6ec4b1fd0f714b232fe496.png";